import React, { Component, Fragment } from "react";
import TabelaMetaRealizado from "../../Components/ProducaoSTI/Realizado/Relatorio3/Index";
import NomeUnidade from "../../Components/UI/NomeUnidade";
import MenuRelatorioSTI from "./menuRelatorioSTI";

export default class PageRelatorio2 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Relatório"
        }
        
    }

    render() {
        return(
            <Fragment>

                <NomeUnidade unidade={"Relatórios"} />

                <div className="content">
                    <MenuRelatorioSTI />
                    <div className="row">
                        <div className="col-md-12">
                            <TabelaMetaRealizado />
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}